import { Button, Chip } from '@material-ui/core'
import clsx from 'clsx'
import moment from 'moment'
import { useMemo } from 'react'
import { useDate } from '../../hooks/useDate'
import QuickTable from '../QuickTable'
import { useStyles } from './style'

export function CompaniesTable({
  onImpersonate,
  onSendAccessLink,
  records,
  onSelect,
  loading
}) {
  const { dateToClientResume } = useDate()
  const classes = useStyles()

  const columns = useMemo(
    () => [
      {
        field: 'name',
        headerName: 'Nome',
        render: row => {
          const name = row.name || '-'
          const maxLength = 25
          if (name.length > maxLength) {
            return (
              <span title={name} style={{ cursor: 'help' }}>
                {name.substring(0, maxLength).trim()}...
              </span>
            )
          }
          return name
        }
      },

      // { field: 'email', headerName: 'E-mail' },
      // { field: 'phone', headerName: 'Telefone' },
      // {
      //   field: 'resposavel',
      //   headerName: 'Responsável',
      //   render: row => {
      //     if (!row.resposavel) return '-'
      //     const firstName = row.resposavel.trim().split(' ')[0]
      //     return <span title={row.resposavel}>{firstName}</span>
      //   }
      // },
      {
        field: 'plan',
        headerName: 'Plano',
        render: row => {
          const hasPlan = row.planId !== null && row.plan

          if (!hasPlan) return '-'

          return (
            <Chip
              label={row.plan.name}
              variant="outlined"
              size="small"
              className={clsx(classes.chipBase, [classes.chipPlan])}
            />
          )
        }
      },
      {
        field: 'status',
        headerName: 'Status',
        render: row => {
          const isActive = row.status !== false
          return (
            <Chip
              label={isActive ? 'Ativo' : 'Inativo'}
              size="small"
              variant="contained"
              className={clsx(classes.chipBase, {
                [classes.chipActive]: isActive,
                [classes.chipInactive]: !isActive
              })}
            />
          )
        }
      },
      {
        field: 'campaigns',
        headerName: 'Campanhas',
        render: row => {
          const setting = row.settings?.find(s => s.key === 'campaignsEnabled')
          const isEnabled = setting?.value === 'true' || setting?.value === true

          return (
            <Chip
              label={isEnabled ? 'Ativo' : 'Inativo'}
              size="small"
              variant="contained"
              className={clsx(classes.chipBase, {
                [classes.chipActive]: isEnabled,
                [classes.chipInactive]: !isEnabled
              })}
            />
          )
        }
      },

      {
        field: 's3Storage',
        headerName: 'S3 Storage',
        render: row => {
          const metadata = row.metadata?.find(m => m.key === 's3StorageUsage')
          if (!metadata?.value) return '-'
          const sizeInBytes = parseFloat(metadata.value)
          if (sizeInBytes >= 1073741824)
            return `${(sizeInBytes / 1073741824).toFixed(2)} GB`
          if (sizeInBytes >= 1048576)
            return `${(sizeInBytes / 1048576).toFixed(2)} MB`
          if (sizeInBytes >= 1024)
            return `${(sizeInBytes / 1024).toFixed(2)} KB`
          return `${sizeInBytes} bytes`
        }
      },
      {
        field: 'createdAt',
        headerName: 'Criação',
        render: row => dateToClientResume(row.createdAt)
      },
      {
        field: 'dueDate',
        headerName: 'Vencimento',
        render: row => dateToClientResume(row.dueDate)
      },
      {
        field: 'recurrence',
        headerName: 'Recorrência',
        render: row => (
          <span style={{ fontSize: '0.75rem', opacity: 0.75 }}>
            {row.recurrence}
          </span>
        )
      },
      {
        field: 'impersonate',
        render: row => (
          <Button
            className={classes.buttonImpersonate}
            disabled={loading}
            onClick={() => onImpersonate && onImpersonate(row)}
            variant="outlined"
            aria-label={`Acessar sistema como a empresa ${row.name || ''}`}
          >
            Acessar
          </Button>
        )
      }
      // {
      //   field: 'sendAcessLink',
      //   render: row => (
      //     <Button
      //       className={classes.buttonImpersonate}
      //       loading={loading}
      //       onClick={() => onSendAccessLink(row.userEmail)}
      //       variant="outlined"
      //     >
      //       Enviar Link de Acesso
      //     </Button>
      //   )
      // }
    ],
    [dateToClientResume, loading, onImpersonate, onSelect]
  )

  const getRowStyle = record => {
    if (!record.dueDate || !moment(record.dueDate).isValid()) return {}

    const now = moment().startOf('day')
    const dueDate = moment(record.dueDate).startOf('day')
    const diff = dueDate.diff(now, 'days')

    if (diff === 5) return { backgroundColor: '#ff91011a' }
    if (diff >= -3 && diff <= 4) return { backgroundColor: '#ff75751d' }
    if (diff === -4) return { backgroundColor: '#fa8c8c38' }

    return {}
  }

  const customCellRenderer = useMemo(() => {
    const renderers = {}
    columns.forEach(col => {
      if (col.render) {
        renderers[col.field] = col.render
      }
    })
    return renderers
  }, [columns])

  return (
    <QuickTable
      data={records}
      columns={columns}
      loading={loading}
      actions={['edit']}
      onEdit={onSelect}
      customCellRenderer={customCellRenderer}
      showAlternatingRows={false}
      tableProps={{
        style: { width: '100%' },
        'aria-label':
          'Tabela de gerenciamento de empresas cadastradas e vencimentos'
      }}
      customRowClass={item => getRowStyle(item)}
    />
  )
}
